import { generateUrl } from "@services/generateUrl/generateUrl"
import { onRequestSuccess, onResponseRejected } from "@services/interceptors"
import axios from "axios"

const FCUSER_URL = generateUrl()

const fcUserServiceApiInstance = axios.create({
    baseURL: `${FCUSER_URL}/fcUser`
})

fcUserServiceApiInstance.interceptors.request.use(onRequestSuccess, undefined)
fcUserServiceApiInstance.interceptors.response.use(undefined, onResponseRejected)

export default fcUserServiceApiInstance
